import { Link, useLoaderData, useParams } from 'react-router';
import utils, { covertTimestampISO } from '../utils';

function History() {

    const { history } = useLoaderData();

    return (
        <>
            <div className='mb-4'>
                <img src="/images/rewind.png" alt="paper and pencil icon" className='inline w-16 aspect-square mr-4' />
                <h2 className='inline text-3xl font-semibold mb-2 align-middle'>Article history</h2>
            </div>
            {history && history.map((snapshot: Record<string, any>, index: number) => {
                return <Link
                    to={snapshot["updated_at"] ? `/${snapshot["article_path"]}` : `/history/preview/${snapshot['revision_id']}`}
                    className={
                        'w-full flex flex-wrap items-center justify-between pb-2 border-b border-b-outline cursor-pointer '
                    }
                    key={index}
                >
                    <div>
                        <p>
                            <span className='text-sm mr-2 font-semibold'>{utils.timeFromTimestamp(covertTimestampISO(snapshot["created_at"]), true)}</span>
                            <span className='text-sm text-primary'>{`/${snapshot["article_path"]}`}</span>
                        </p>
                        <p className='text-xl font-semibold'>{snapshot.title}</p>
                        {snapshot["published_at"] ?
                                <span className='text-sm font-semibold text-radiationGreen'>Created {utils.getLastOnline(covertTimestampISO(snapshot["published_at"]))}</span> :
                                <span className='text-sm font-semibold text-orange-500'>Drafted {utils.getLastOnline(covertTimestampISO(snapshot["updated_at"] || snapshot["created_at"]))}</span>
                        }
                    </div>
                    <img src={snapshot.user.profile} alt={snapshot.user.username} className='rounded-lg h-16 aspect-square' />
                </Link>
            })}
        </>
    )
}

export default History